import React, { useState, useMemo, useContext } from 'react';
import { node } from 'prop-types';
import { useWidth } from '../../../Utils';
const useSidebarStrategy = () => {
  const width = useWidth();
  if (width === 'xs') return 'full-overlay';
  if (width === 'sm' || width === 'md') return 'partial-overlay';
  return 'side-by-side';
};
export const SidebarContext = /*#__PURE__*/React.createContext({
  isSidebarOpen: false,
  setIsSidebarOpen: () => {},
  sidebarStrategy: 'side-by-side'
});
export const useSidebarContext = () => useContext(SidebarContext);
export const SidebarContextProvider = _ref => {
  let {
    children
  } = _ref;
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const sidebarStrategy = useSidebarStrategy();
  const sidebarContext = useMemo(() => {
    return {
      isSidebarOpen,
      setIsSidebarOpen,
      sidebarStrategy
    };
  }, [isSidebarOpen, setIsSidebarOpen, sidebarStrategy]);
  return /*#__PURE__*/React.createElement(SidebarContext.Provider, {
    value: sidebarContext
  }, children);
};
SidebarContextProvider.defaultProps = {
  children: null
};
SidebarContextProvider.propTypes = {
  children: node
};